import { AppConfig } from '../../app-config'

function getLocale({ router, locale }) {
	const tmpLocale =
		router.locale !== AppConfig.defaultLocale ? router.locale : ''

	return (tmpLocale || '').length
		? tmpLocale
		: locale !== AppConfig.defaultLocale
		? locale
		: ''
}

export default getLocale
